"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemappingContext = exports.RiskContext = exports.ProjectContext = exports.OverviewContext = exports.ContractContext = exports.Context = void 0;
var Context = (function () {
    function Context() {
    }
    return Context;
}());
exports.Context = Context;
var ContractContext = (function (_super) {
    __extends(ContractContext, _super);
    function ContractContext(contract) {
        var _this = _super.call(this) || this;
        _this.contract = contract;
        return _this;
    }
    return ContractContext;
}(Context));
exports.ContractContext = ContractContext;
var OverviewContext = (function (_super) {
    __extends(OverviewContext, _super);
    function OverviewContext(projectGroup) {
        var _this = _super.call(this) || this;
        _this.projectGroup = projectGroup;
        return _this;
    }
    return OverviewContext;
}(Context));
exports.OverviewContext = OverviewContext;
var ProjectContext = (function (_super) {
    __extends(ProjectContext, _super);
    function ProjectContext(project) {
        var _this = _super.call(this) || this;
        _this.project = project;
        return _this;
    }
    return ProjectContext;
}(Context));
exports.ProjectContext = ProjectContext;
var RiskContext = (function (_super) {
    __extends(RiskContext, _super);
    function RiskContext(project_id, risk_id) {
        var _this = _super.call(this, project_id) || this;
        _this.risk = risk_id;
        return _this;
    }
    return RiskContext;
}(ProjectContext));
exports.RiskContext = RiskContext;
var RemappingContext = (function (_super) {
    __extends(RemappingContext, _super);
    function RemappingContext(project_id, user_id) {
        var _this = _super.call(this, project_id) || this;
        _this.user = user_id;
        return _this;
    }
    return RemappingContext;
}(ProjectContext));
exports.RemappingContext = RemappingContext;
